import React from 'react';
import { Trans } from 'react-i18next';
import { SongInsights } from '../../Dashboard';
import { getStationNameList } from '../SmartInsightsCardContentHelper';

// 4. Region card content logic
export const getRegionCardContent = (
  songInsights: SongInsights,
  isHovering = false
): React.ReactNode => {
  if (isHovering) {
    return <Trans i18nKey="REGION_HOVER" components={{ bold: <strong /> }} />;
  }
  const regions = songInsights?.songInsightsData?.top_regions;
  if (regions) {
    const { items, last } = getStationNameList(regions.map((r) => r.name));
    if (regions.length > 0) {
      if (regions.length === 1) {
        return (
          <Trans
            i18nKey="REGION_SINGLE"
            values={{ region: last }}
            components={{ bold: <strong /> }}
          />
        );
      }
    }
    if (regions.length >= 2) {
      return (
        <Trans
          i18nKey="REGION_MULTI"
          values={{
            regionlist: items,
            lastRegion: last,
          }}
          components={{ bold: <strong /> }}
        />
      );
    }
  }
  return null;
};
